export default "__VITE_ASSET__DmSBszxf__"